// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: "AIzaSyD_DMPTBePUWQLgp-2aOUNKQz5l4ohn8tQ",
    authDomain: "time-booth.firebaseapp.com",
    projectId: "time-booth",
    storageBucket: "time-booth.appspot.com",
    messagingSenderId: "474640014050",
    appId: "1:474640014050:web:f3b944bfb2c5a73a60dcbb",
    measurementId: "G-BS1CG29R4E"
  };